<template>
  <div>
    <MeridiaButton
      :type="type"
      :size="size"
      :disabled="disabled"
      :icon_position="icon_position"
      :label="label"
      :icon="icon"
      :loading="loading"
      :pt="passThroughButton.value"
      @click="toggle"
    >
      <slot v-if="slots.default" />
      <template v-if="slots.customIcon" v-slot:customIcon>
        <slot name="customIcon" />
      </template>
    </MeridiaButton>
    <PrimeMenu ref="menu" :popup="true" :model="model" :pt="passThroughMenu">
      <template
        v-for="name in Object.keys(slots).filter(
          (key) => !['default', 'customIcon'].includes(key)
        )"
        :key="name"
        v-slot:[name]="slotData"
      >
        <slot :name="name" v-bind="slotData || {}"></slot>
      </template>
    </PrimeMenu>
  </div>
</template>

<script setup lang="ts">
import { PassThrough } from '@primevue/core';
import { ModelType } from './types';
import { ButtonProps } from '../types';
import { usePassThrough } from 'primevue/passthrough';
import { ButtonPassThroughOptions, MenuSlots } from 'primevue';
import MeridiaButton from '../MeridiaButton.vue';
import PrimeMenu, { MenuPassThroughOptions } from 'primevue/menu';
import { ref } from 'vue';

const props = withDefaults(
  defineProps<
    Omit<ButtonProps, 'pt'> & {
      model: ModelType[];
      pt?: {
        button: PassThrough<ButtonPassThroughOptions>;
        menu: PassThrough<MenuPassThroughOptions>;
      };
    }
  >(),
  {}
);

const slots = defineSlots<
  MenuSlots & {
    default: () => any;
    customIcon: () => any;
  }
>();

const emit = defineEmits<{
  toogle: [e: MouseEvent];
}>();

const passThroughButton = usePassThrough(
  props.pt?.button,
  {} as ButtonPassThroughOptions,
  { mergeSections: false, mergeProps: true }
) as PassThrough<ButtonPassThroughOptions> & { value: PassThrough<ButtonPassThroughOptions> };

const passThroughMenu = usePassThrough(
  props.pt?.menu,
  {
    itemLabel: {
      class: 'text-body-base text-neutral-text-body'
    },
    itemContent: {
      class: 'hover:bg-neutral-surface-muted'
    }
  } as MenuPassThroughOptions,
  { mergeSections: false, mergeProps: true }
) as PassThrough<MenuPassThroughOptions>;

const menu = ref<InstanceType<typeof PrimeMenu>>();
function toggle(event: MouseEvent) {
  menu.value.toggle(event);
  emit('toogle', event);
}
</script>

<style lang="scss" scope></style>
